import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { ProductImage } from "../../services/types/productImage.type";

export const productImagesApi = createApi({
  reducerPath: "productImagesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_ADMIN_API_URL, // например, "https://api.miyukon.store/admin"
    credentials: "include", // для передачи cookies
  }),
  endpoints: (builder) => ({
    // Загрузка нового изображения для товара
    uploadProductImage: builder.mutation<
      ProductImage,
      { productUuid: string; formData: FormData }
    >({
      query: ({ productUuid, formData }) => ({
        url: `/products/${productUuid}/images/upload`,
        method: "POST",
        body: formData,
      }),
      transformResponse: (response: {
        status: string;
        message: string;
        data: ProductImage;
      }) => response.data,
    }),
    // Обновление метаданных изображения
    updateProductImage: builder.mutation<
      ProductImage,
      {
        productUuid: string;
        imageUuid?: string;
        updateData: Partial<Omit<ProductImage, "uuid" | "imageUrl">>;
      }
    >({
      query: ({ productUuid, imageUuid, updateData }) => ({
        url: `/products/${productUuid}/images/${imageUuid}`,
        method: "PATCH",
        body: updateData,
      }),
      transformResponse: (response: {
        status: string;
        message: string;
        data: ProductImage;
      }) => response.data,
    }),
    // Soft delete изображения
    deleteProductImage: builder.mutation<
      { uuid: string },
      { productUuid: string; imageUuid: string }
    >({
      query: ({ productUuid, imageUuid }) => ({
        url: `/products/${productUuid}/images/${imageUuid}`,
        method: "DELETE",
      }),
      transformResponse: (_: any, __: any, arg: { imageUuid: string }) => ({
        uuid: arg.imageUuid,
      }),
    }),
  }),
});

export const {
  useUploadProductImageMutation,
  useUpdateProductImageMutation,
  useDeleteProductImageMutation,
} = productImagesApi;
